import { Component } from "../components/index"
import gsap from "gsap"
import { qsa, qs, bounds } from "../utils/index"
import TextSplitScrollTrigger from "../components/TextSplitScrollTrigger"
import Sticky from "../../scripts/components/Sticky"
import store from "../store"
import { ScrollTrigger } from "../libraries/gsap/index"

export default class LongTextImages extends Component {
  constructor(obj) {
    super(obj)

    this.splitText = qsa("[data-split]", this.el)
    this.textSplitter = new TextSplitScrollTrigger({
      el: this.el,
      splitText: this.splitText,
      animate: this.animate.bind(this),
    })
  }

  animate() {
    const headerText = qsa(".header-text .line-0", this.el)
    const leftText = qsa(".left .line-0", this.el)
    const rightText = qsa(".right .line-0", this.el)
    const images = qsa(".image-wrapper img", this.el)
    const mobileWrapper = qsa(".mobile", this.el)

    gsap.from(headerText, {
      y: 50,
      duration: 1.2,
      autoAlpha: 0,
      stagger: 0.1,
      scrollTrigger: {
        trigger: headerText,
        start: "top bottom",
      },
    })
    gsap.from(leftText, {
      y: 50,
      duration: 1.2,
      autoAlpha: 0,
      stagger: 0.1,
      scrollTrigger: {
        trigger: leftText,
        start: "top bottom",
      },
    })
    gsap.from(rightText, {
      y: 50,
      duration: 1.2,
      autoAlpha: 0,
      stagger: 0.07,
      scrollTrigger: {
        trigger: rightText,
        start: "top bottom",
      },
    })

    mobileWrapper.forEach(wrapper => {
      const img = qs(".cover", wrapper)
      gsap.from(img, {
        y: "100%",
        duration: 1.5,
        scrollTrigger: {
          trigger: wrapper,
          start: "top bottom",
        },
      })
    })

    gsap.from(images, {
      y: "100%",
      stagger: 0.1,
      duration: 1.5,
      scrollTrigger: {
        trigger: images,
        start: "top bottom",
      },
    })
  }
}
